import { render, staticRenderFns } from "./KanbanBoardWrapper.vue?vue&type=template&id=6c2cb97c&scoped=true"
import script from "./KanbanBoardWrapper.vue?vue&type=script&lang=js"
export * from "./KanbanBoardWrapper.vue?vue&type=script&lang=js"
import style0 from "./KanbanBoardWrapper.vue?vue&type=style&index=0&id=6c2cb97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2cb97c",
  null
  
)

export default component.exports